import type { Contact } from "@/api/content";
import { Button } from "@/components";
import { useLang } from "@/i18n/LanguageContext";
import type { BlockEditorProps } from "./types";

export function ContactCardEditor({ content, onChange }: BlockEditorProps) {
  const { t } = useLang();
  const contacts = content.contacts ?? [];
  const set = (next: Contact[]) => onChange({ ...content, contacts: next });
  const patch = (i: number, p: Partial<Contact>) => set(contacts.map((c, j) => (j === i ? { ...c, ...p } : c)));

  return (
    <div>
      {contacts.length === 0 && <p className="no-data-message">{t("Nog geen contacten.", "No contacts yet.")}</p>}
      {contacts.map((c, i) => (
        <div key={i} className="block-item">
          <button className="icon-btn block-remove" title={t("Verwijderen", "Remove")} onClick={() => set(contacts.filter((_, j) => j !== i))}>×</button>
          <div className="field">
            <label>{t("Naam", "Name")}</label>
            <input value={c.name} onChange={(e) => patch(i, { name: e.target.value })} placeholder="Jan Jansen" />
          </div>
          <div className="field">
            <label>{t("Functie / rol", "Role")}</label>
            <input value={c.role} onChange={(e) => patch(i, { role: e.target.value })} placeholder={t("Teamlead Service", "Service team lead")} />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <div className="field">
              <label>E-mail</label>
              <input value={c.email} onChange={(e) => patch(i, { email: e.target.value })} placeholder="jan@acme.nl" />
            </div>
            <div className="field">
              <label>{t("Telefoon", "Phone")}</label>
              <input value={c.phone} onChange={(e) => patch(i, { phone: e.target.value })} placeholder="06-12345678" />
            </div>
          </div>
          <div className="field" style={{ marginBottom: 0 }}>
            <label>{t("Notitie", "Note")}</label>
            <input value={c.note} onChange={(e) => patch(i, { note: e.target.value })} />
          </div>
        </div>
      ))}
      <Button variant="outline" onClick={() => set([...contacts, { name: "", role: "", email: "", phone: "", note: "" }])}>+ {t("Contact", "Contact")}</Button>
    </div>
  );
}
